module.exports = __webpack_public_path__ + "img/icon_statement.bbd1e47c.png";